import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defaultHighlightsHeader: {
    defaultMessage: 'Available features in {planName}:',
    description: 'Header for section that highlights features included in a plan',
    id: 'hPVUkA',
  },
  higherTierHighlightsHeader: {
    defaultMessage: 'Everything in {previousTierPlanName}, plus:',
    description: 'Header for section that highlights features included in a plan, plus the previous tiers features',
    id: 'LHOJuw',
  },

  // Free plan features
  discountedCarrierRates: {
    defaultMessage: 'Discounted carrier rates',
    description: 'Subscription plan feature: Discounted carrier rates',
    id: 'tWjzR2',
  },
  trackingEmails: {
    defaultMessage: 'Tracking emails',
    description: 'Subscription plan feature: Tracking emails',
    id: 'dB77AK',
  },
  oneStoreConnection: {
    defaultMessage: '1 store connection',
    description: 'Subscription plan feature: 1 store connection',
    id: 'd6Tx0Y',
  },

  // Starter plan features
  unlimitedStoreConnections: {
    defaultMessage: 'Unlimited store connections',
    description: 'Subscription plan feature: Unlimited store connections',
    id: 'LRS2WA',
  },
  automatedRateShopping: {
    defaultMessage: 'Automated Rate Shopper',
    description: 'Subscription plan feature: Automated Rate Shopper',
    id: 'UvPNj5',
  },
  returnLabels: {
    defaultMessage: 'Return labels',
    description: 'Subscription plan feature: Return labels',
    id: '7AeDb6',
  },
  basicAutomations: {
    defaultMessage: 'Basic automations',
    description: 'Subscription plan feature: Basic automations',
    id: '04OK1F',
  },
  reporting: {
    defaultMessage: 'Reporting',
    description: 'Subscription plan feature: Reporting',
    id: 'phaFrr',
  },
  chatSupport: {
    defaultMessage: 'Chat support',
    description: 'Subscription plan feature: Chat support',
    id: 'yp80YE',
  },

  // Standard plan features
  unlimitedAutomations: {
    defaultMessage: 'Unlimited automations',
    description: 'Subscription plan feature: Unlimited automations',
    id: 'FWLHUb',
  },
  combineSplitOrders: {
    defaultMessage: 'Combine & auto split orders',
    description: 'Subscription plan feature: Combine & auto split orders',
    id: 'uGoc8Z',
  },
  bringYourExistingCarrierAccount: {
    defaultMessage: 'Bring your existing carrier account',
    description: 'Subscription plan feature: Bring your existing carrier account',
    id: 'rWRQHe',
  },
  advancedReturnFeatures: {
    defaultMessage: 'Advanced Return management',
    description: 'Subscription plan feature: Advanced Return management',
    id: '0HQKyd',
  },
  basicWarehouseManagementAndInventorySync: {
    defaultMessage: 'Basic Warehouse (packing, mobile picking, barcodes)',
    description: 'Subscription plan feature: Basic Warehouse (packing, mobile picking, barcodes)',
    id: 'yZZ7+y',
  },
  inventoryTrackingSyncAndProductBundles: {
    defaultMessage: 'Inventory tracking, sync, & product bundles',
    description: 'Subscription plan feature: Inventory tracking, sync, & product bundles',
    id: 'OeW1XE',
  },
  shippingAPI: {
    defaultMessage: 'Shipping API',
    description: 'Subscription plan feature: Shipping API',
    id: 'PK8VVv',
  },
  phoneSupport: {
    defaultMessage: 'Phone support',
    description: 'Subscription plan feature: Phone support',
    id: 'Ukcwsc',
  },

  // Premium plan features
  inventoryManagement: {
    defaultMessage: 'Advanced Inventory (scan to receive, purchase orders, forecasting)',
    description: 'Subscription plan feature: Advanced Inventory (scan to receive, purchase orders, forecasting)',
    id: 'A75kIU',
  },
  advancedWarehouse: {
    defaultMessage: 'Advanced Warehouse (pick-to-tote)',
    description: 'Subscription plan feature: Advanced Warehouse (pick-to-tote)',
    id: '+bnd8i',
  },
  customAnalytics: {
    defaultMessage: 'Custom Analytics (edit, schedule, alert)',
    description: 'Subscription plan feature: Custom Analytics (edit, schedule, alert)',
    id: '8nQ5cS',
  },
  autoRouting: {
    defaultMessage: 'Order Routing',
    description: 'Subscription plan feature: Order Routing',
    id: 'ag3G3t',
  },
  cubiscan: {
    defaultMessage: 'Cubiscan',
    description: 'Subscription plan feature: Cubiscan',
    id: 'MbCoHy',
  },
  openDatabaseConnectivity: {
    defaultMessage: 'Open Database Connectivity (ODBC)',
    description: 'Subscription plan feature: Open Database Connectivity (ODBC)',
    id: 'EXBBCI',
  },
});
